import cx from 'classnames'
import React, { useState, useEffect, useRef } from 'react'
import { animated, Keyframes } from 'react-spring'

import Link from '../Link/Link'
import ServiceMenuMobile from '../ServiceMenuMobile/ServiceMenuMobile'
import styles from './sideMenuMobile-style.css'
import type { ServiceMenuItemViewModel } from '@/view-models/ServiceMenuItemViewModel'
import Accordion from '@/components/Accordion/Accordion'
import ServiceMenuMobileLinks from '@/components/ServiceMenuMobileLinks/ServiceMenuMobileLinks'
import PageLinks from '@/components/PageLinks/PageLinks'

const Sidebar: any = Keyframes.Spring({
  open: { delay: 0, x: 0 },
  close: async (call) => {
    await call({ delay: 0, x: -100 })
  },
})

const PageLinksComponent = ({ pageLinks }) => {
  if (!pageLinks) return null
  return <PageLinks items={pageLinks} />
}

const SideMenuMobile: React.FC<Props> = ({
                                           isOpen,
                                           currentLinksOpen,
                                           mobileCurrentItems,
                                           topLevelLinks,
                                           serviceMenu,
                                           onBackClick,
                                           searchBtn,
                                           notificationCount,
                                           myPageLink,
                                           onSubmit,
                                           onCloseHeaderOverlay,
                                           pageLinks
                                         }) => {
  const sidebarState = isOpen ? 'open' : 'close'

  const [linksToRender, setLinksToRender] = useState<Array<ServiceMenuItemViewModel>>(() => {
    if (!serviceMenu || !serviceMenu.links) return []

    const scopeMap = new Map()

    serviceMenu.links.forEach((item) => {
      const scopeKey = item.scope?.title || 'no-scope'
      if (!scopeMap.has(scopeKey)) {
        scopeMap.set(scopeKey, { scope: item.scope, items: [] })
      }
      scopeMap.get(scopeKey).items.push(item)
    })

    const firstScopeItems = Array.from(scopeMap.values())[0]?.items || []
    const noScopeItems = serviceMenu.links.filter((item) => !item.scope)

    if (scopeMap.size === 1 && scopeMap.has('no-scope')) {
      return noScopeItems
    }

    return [...firstScopeItems, ...noScopeItems]
  })

  useEffect(() => {
    const body = document.getElementsByTagName('body')[0]

    if (isOpen) {
      setTimeout(() => {
        body.style.overflow = 'hidden'
        body.style.height = '100vh'
        body.style.width = '100vw'
      }, 400)
    } else {
      body.style.overflow = 'visible'
      body.style.width = 'auto'
      body.style.height = 'auto'
    }

    return () => {
      body.style.overflow = 'visible'
      body.style.width = 'auto'
      body.style.height = 'auto'
    }
  }, [isOpen])

  const renderItem = (item: ServiceMenuItemViewModel, index: number) => {
    if (item.links) {
      return (
        <Accordion
          key={index}
          className={styles.serviceMenuItem}
          items={[
            {
              header: item.title,
              component: <ServiceMenuMobileLinks items={item.links} cardLinks={item.cardLinks} />,
            },
          ]}
        />
      )
    }

    if (item.link) {
      return (
        <Link
          key={index}
          {...item.link}
          className={cx(styles.serviceMenuMobileItem, styles.serviceMenuItem)}
          secondary
        >
          {(item.link && item.link.label) || item.title}
        </Link>
      )
    }

    return null
  }


  if (!mobileCurrentItems) return null


  return (
    <Sidebar native state={sidebarState}>
      {({ x }) => (
        <animated.div
          className={cx(styles.sideMenu, isOpen && styles.isOpen)}
          style={{
            transform: x.interpolate((x) => `translate3d(${x}%,0,0)`),
            backgroundColor: 'white',
          }}
        >
          {serviceMenu && (
            <ServiceMenuMobile
              serviceMenu={serviceMenu}
              searchBtn={searchBtn}
              isOpen={isOpen}
              onSubmit={onSubmit}
              onScopeClick={setLinksToRender}
            />
          )}
          <PageLinksComponent pageLinks={pageLinks} />
          {linksToRender && linksToRender.map(renderItem)}
        </animated.div>
      )}
    </Sidebar>
  )
}

export default SideMenuMobile